import { Typography, Card, Space, Divider, Image, Row, Col } from 'antd';
import anytime from '../../assets/anytime.png';
import {
  card,
  cardBodyStyle,
  space,
  cardTitle,
  divider,
  infoText,
  imageRow
} from './styles';

const { Title, Text } = Typography;

export default function AuthCard({
  title,
  subtitle,
  children,
  style,
  showImage = true
}) {
  return (
    <Card
      bordered={false}
      style={{ ...card, ...style }}
      bodyStyle={cardBodyStyle}
    >
      <Space direction="vertical" size={4} style={space}>
        <Title level={3} style={cardTitle}>
          {title}
        </Title>
        <Divider style={divider} />
        <Text type="secondary" style={infoText}>
          {subtitle}
        </Text>
      </Space>
      {children}
      {showImage && (
        <Row justify="center" align="middle" style={imageRow}>
          <Col>
            <Image src={anytime} preview={false} width={120} />
          </Col>
        </Row>
      )}
    </Card>
  );
}
